import React from 'react';

interface ToggleSwitchProps {
  label: string;
  isChecked: boolean;
  onChange: () => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ label, isChecked, onChange }) => (
  <label className="flex items-center cursor-pointer">
    <span className="mr-3 text-sm text-gray-600">{label}</span>
    <div className="relative">
      <input
        type="checkbox"
        className="sr-only"
        checked={isChecked}
        onChange={onChange}
      />
      <div className={`block w-10 h-6 rounded-full transition-colors ${
        isChecked ? 'bg-talaera-blue' : 'bg-gray-300'
      }`} />
      <div className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform transform ${
        isChecked ? 'translate-x-4' : ''
      }`} />
    </div>
  </label>
);

export default ToggleSwitch;
